import { Button, CircularProgress } from "@mui/material";
import { ButtonProps } from "@mui/material/Button/Button";
import { ReactNode } from "react";

interface Props extends ButtonProps {
	children: ReactNode;
	isLoading: boolean;
}

export const ButtonWithLoading = ({ children, isLoading, ...props }: Props) => {
	return (
		<Button {...props} disabled={isLoading}>
			{isLoading && <CircularProgress size={"1rem"} />}
			{children}
		</Button>
	);
};
